import { slice } from '../slices/i18n';

const nameSpace = slice.name;

export const translateLanguageSelector = (state: RootState) => state[nameSpace].translateLanguage;
export const translationsSelector = (state: RootState) => state[nameSpace].translations;
